import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';
import React from 'react';

export const steps = [
  { label: 'Identité & Fiche patient', subtitle: 'Coordonnées et informations civiles du patient', icon: PersonOutlineIcon },
  { label: 'Chemin de Vie', subtitle: 'Contexte personnel et parcours de vie', icon: AltRouteIcon },
  { label: 'Parcours Médical & Hygiène', subtitle: 'Historique médical, traitements et mode de vie', icon: MonitorHeartIcon },
  { label: 'Documents & Compte Client', subtitle: 'Pièces jointes et accès au portail patient', icon: DescriptionOutlinedIcon },
];

export const ColorConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 18,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#E0E5F2',
    borderTopWidth: 2,
    borderRadius: 1,
  },
  [`&.${stepConnectorClasses.active}.${stepConnectorClasses.line}`]: {
    borderColor: '#4318FF',
  },
  [`&.${stepConnectorClasses.completed}.${stepConnectorClasses.line}`]: {
    borderColor: '#4318FF',
  },
}));

const StepIconRoot = styled('div')(({ ownerState }) => ({
  width: 36,
  height: 36,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ownerState.active || ownerState.completed ? '#4318FF' : '#EDF0F8',
  color: ownerState.active || ownerState.completed ? '#fff' : '#A3AED0',
  transition: 'background-color 0.2s ease',
}));

export const CustomStepIcon = (props) => {
  const { active, completed, icon } = props;
  const StepIconComponent = steps[icon - 1]?.icon || PersonOutlineIcon;
  return (
    <StepIconRoot ownerState={{ active, completed }}>
      {completed ? <CheckCircleIcon fontSize="small" /> : <StepIconComponent fontSize="small" />}
    </StepIconRoot>
  );
};

export const SectionHeader = ({ title, description }) => (
  <Box sx={{ mb: 2 }}>
    <Typography sx={{ fontWeight: 700, color: '#2B3674', fontSize: '0.95rem' }}>{title}</Typography>
    {description && (
      <Typography sx={{ color: '#A3AED0', fontSize: '0.8rem', mt: .25 }}>{description}</Typography>
    )}
  </Box>
);